import { render, staticRenderFns } from "./AddSize.vue?vue&type=template&id=2ecbfaaa&scoped=true"
import script from "./AddSize.vue?vue&type=script&lang=js"
export * from "./AddSize.vue?vue&type=script&lang=js"
import style0 from "./AddSize.vue?vue&type=style&index=0&id=2ecbfaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecbfaaa",
  null
  
)

export default component.exports